import React from "react";
import { useParams } from "react-router-dom";

import { Item } from "../ItemList";
import { CameraListParams } from "./interfaces";
import { CameraListView } from "./views";
import { useCamerasApi } from "../../hooks/use-cameras";
import { Camera } from "../../interfaces";

/**
 * Shows a list of cameras (fleets) and allows:
 * - Navigating to an edit screen for individual accounts
 * - Deleting one or more accounts
 */
export const CameraList: React.FC = () => {
  const { accountId } = useParams<CameraListParams>();
  const [data, setData] = React.useState<Camera[]>([]);
  const {
    loading,
    error,
    deleteCamera,
    deleting,
    getCameras,
  } = useCamerasApi();

  React.useEffect(() => {
    async function fetchData() {
      const data = await getCameras(accountId);
      setData(data ? data : []);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run this once
  }, [accountId]);

  /**
   * Used to determine whether to show a dismissable badge
   * confirming that a delete operation succeeded
   *
   * TODO: handle error via same mechanism
   */
  const [deleteSuccess, setDeleteSuccess] = React.useState(false);

  const handleDelete = async (items: Item[]) => {
    try {
      for (const item of items) {
        await deleteCamera(item.id);
      }

      // Update the vehicle list state to remove the deleted vehicle
      setData((prevList) =>
        prevList.filter(
          (vehicle) => !items.some((item) => item.id === vehicle.id)
        )
      );

      setDeleteSuccess(true);
    } catch (error) {
      console.error("Failed to delete vehicle:", error);
      setDeleteSuccess(false);
      // Handle errors here, possibly set an error state
    }
  };

  return (
    <div>
      <CameraListView
        data={data}
        loading={loading || deleting}
        error={error}
        accountId={accountId}
        onDelete={handleDelete}
        deleteSuccess={deleteSuccess}
      />
    </div>
  );
};
